import {
  Box, Button,
  Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography, useMediaQuery
} from "@material-ui/core";
import { useTheme } from "@mui/material/styles";
import { AgGridReact } from "ag-grid-react";
import React, { Fragment, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { TableChart, ViewList } from "@material-ui/icons";
import Skeleton from "@mui/material/Skeleton";
import Complete from "images/complete.jpg";
import {
  apiPaths,
  get, postData
} from "modules/platform-components/api-integration-util";

import { useStyles } from "./style";
import TabView from "./TabView";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { getUserDetails } from "modules/platform-components/utils/shared-data.service";

const Classes = () => {
  const classes = useStyles();
  const theme = useTheme();
  let history = useHistory();

  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [liveRowData, setLiveRowData] = useState([]);
  const [currentView, setCurrentView] = useState("tab");
  const url = "faculty/publishLiveStream";
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleButtonClick = (props: any, type: string) => {
    
    const { data } = props;
    // Call the API using the postData function
    const dataProps = {
      data: {},
      params: {
        liveClassId: props?.data?.liveClassId ?? props?.liveClassId
      },
      headers: {
        tenantId: getUserDetails().tenantId,
        userEmail: getUserDetails().email
      }
    };

    postData(url, dataProps)
      .then((response) => {
      if (data?.status === "In Progress" || props?.status === "In Progress") {
        setOpen(true);
        setData(data ?? props);
      } else {
        updateLiveClass(props?.data ?? props, type)

        if (props?.data?.classType === "ARISE_LIVE_STREAM" || props?.classType === "ARISE_LIVE_STREAM") {
          history.push(
            `/wowza/start-class/${props?.data?.liveClassId ?? props?.liveClassId}`
          );
        } else {
          history.push(
            `/start-class/${props?.data?.liveClassId ?? props?.liveClassId}`
          );
        }
      } })
      .catch((error) => {
        console.error("Error calling API: ", error);
      });
  };

  const handelResume = (props) => {
  // Call the API using the postData function
  const data = {
    data: {},
    params: {
      liveClassId: props?.data?.liveClassId ?? props?.liveClassId
    },
    headers: {
      tenantId: getUserDetails().tenantId,
      userEmail: getUserDetails().email
    }
  };

  postData(url, data)
    .then((response) => {
      updateLiveClass(props?.data ?? props, 'resume')
      if (props?.data?.classType === "ARISE_LIVE_STREAM" || props?.classType === "ARISE_LIVE_STREAM") {
        history.push(
          `/wowza/start-class/${props?.data?.liveClassId ?? props?.liveClassId}`
        );
      } else {
        history.push(
          `/start-class/${props?.data?.liveClassId ?? props?.liveClassId}`
        );
      }
    })
    .catch((error) => {
      console.error("Error calling API: ", error);
    });
    }
    
  function ActionButtonRenderer(props) {
    return (
      <Fragment>
        {props?.data?.status === "In Progress" && (
          <Button
            variant="contained"
            color="secondary"
            onClick={() => handelResume(props)}
            style={{
              height: 30,
              textTransform: "capitalize",
              marginTop: 5,
              marginRight: 5,
            }}
          >
            Resume
          </Button>
        )}
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleButtonClick(props, props?.data?.status === "In Progress" ? "completed" : "in_progress")}
          style={{ height: 30, textTransform: "capitalize", marginTop: 5 }}
        >
          {props?.data?.status === "In Progress" ? "Complete" : "Start Class"}
        </Button>
      </Fragment>
    );
  }

  const [columnDefs] = useState([
    { headerName: "Live Class ID", field: "liveClassId" },
    { headerName: "Class Name", field: "title" },
    { headerName: "Topic", field: "topic" },
    { headerName: "Subject", field: "subject" },
    { headerName: "Scheduled Date", field: "scheduledDate" },
    { headerName: "Status", field: "status" },
  ]);
  const [liveColumnDefs] = useState([
    { headerName: "Live Class ID", field: "liveClassId" },
    { headerName: "Class Name", field: "title" },
    { headerName: "Topic", field: "topic" },
    { headerName: "Subject", field: "subject" },
    { headerName: "Scheduled Date", field: "scheduledDate" },
    { headerName: "Status", field: "status" },
    {
      headerName: "Action",
      field: "price",
      cellRendererFramework: ActionButtonRenderer,
    },
  ]);

  const getCompletedLiveClasses = () => {
    get(apiPaths.getCompletedLiveClasses)
      .then((res) => {
        setRowData(res?.result);
      })
      .catch((ele) => {});
  };

  const getLiveClasses = () => {
    setLoading(true);
    postData(apiPaths.getLiveClasses)
      .then((res) => {
        setLiveRowData(res?.result);
        setLoading(false);
      })
      .catch((ele) => {});
  };

  useEffect(() => {
    getLiveClasses();
    getCompletedLiveClasses();
  }, []);

  const handleClose = () => {
    setOpen(false);
    setData([]);
  };

  const handleCardView = () => setCurrentView("tab");
  const handleTableView = () => setCurrentView("table");

  const updateLiveClass = (data , type) => {
    console.log('data: ', data);
    setLoading(true);
    let status = (type === 'completed' ) ? "Completed" : "In Progress";
    postData(
      `${apiPaths.updateLiveClassStatus}?liveClassId=${data?.liveClassId}&status=${status}`
    )
      .then((res) => {
        if (res?.responseCode === 200) {
          getLiveClasses();
          getCompletedLiveClasses();
          setLoading(false);
          handleClose();
        }
      })
      .catch((e) => console.log(e));
  };

  return (
    <Fragment>
      <Box className={classes.tabWrapper}>
        <IconButton
          aria-label="delete"
          size="medium"
          color={currentView === "tab" ? "secondary" : "default"}
          onClick={handleCardView}
        >
          <ViewList />
        </IconButton>
        <IconButton
          aria-label="delete"
          size="medium"
          color={currentView === "table" ? "secondary" : "default"}
          onClick={handleTableView}
        >
          <TableChart />
        </IconButton>
      </Box>

      {currentView === "tab" ? (
        <Fragment>
          {loading ? (
            <Grid container spacing={2}>
              <Skeleton variant="rectangular" width="100%">
                <div style={{ paddingTop: "4%", marginBottom: 15 }} />
              </Skeleton>
              {[1, 2, 3, 4, 5, 6]?.map((el: any, i: number) => (
                <Grid item xs={4}>
                  <Skeleton variant="rectangular" width="100%">
                    <div style={{ paddingTop: "57%", marginTop: 10 }} />
                  </Skeleton>
                  <Skeleton variant="rectangular" width="100%">
                    <div style={{ paddingTop: "5%", marginTop: 10 }} />
                  </Skeleton>
                  <Skeleton variant="rectangular" width="100%">
                    <div style={{ paddingTop: "5%", marginTop: 10 }} />
                  </Skeleton>
                  <Skeleton variant="rectangular" width="100%">
                    <div style={{ paddingTop: "5%", marginTop: 10 }} />
                  </Skeleton>
                  <Skeleton variant="rectangular" width="100%">
                    <div style={{ paddingTop: "5%", marginTop: 10 }} />
                  </Skeleton>
                  <Skeleton variant="rectangular" width="100%">
                    <div style={{ paddingTop: "15%", marginTop: 10 }} />
                  </Skeleton>
                </Grid>
              ))}
            </Grid>
          ) : (
            <TabView
              liveRowData={liveRowData}
              rowData={rowData}
              handleButtonClick={handleButtonClick}
              handelResume={handelResume}
            />
          )}
        </Fragment>
      ) : (
        <Fragment>
          <Typography variant="h5">Live</Typography>
          <Box
            className="ag-theme-alpine ag-theme-balham ag-grid-main"
            style={{
              width: "100%",
              marginTop: 15,
              marginBottom: 35,
              height: "auto",
            }}
          >
            <AgGridReact
              rowData={liveRowData}
              columnDefs={liveColumnDefs}
            ></AgGridReact>
          </Box>
          <Typography variant="h5">Completed</Typography>
          <Box
            className="ag-theme-alpine ag-theme-balham ag-grid-main"
            style={{ width: "100%", marginTop: 15, height: "auto" }}
          >
            <AgGridReact
              rowData={rowData}
              columnDefs={columnDefs}
            ></AgGridReact>
          </Box>
        </Fragment>
      )}

      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Are you wan't to complete the class ?"}
        </DialogTitle>
        <DialogContent
          style={{ width: 600, justifyContent: "center", display: "flex" }}
        >
          <img src={Complete} alt="complete" width={300} />
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Close
          </Button>
          <Button onClick={() => updateLiveClass(data, 'completed')} autoFocus>
            Complete
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};
export default Classes;
